import { useEffect, useState } from "react";

import { EventBusTopic } from "@moodys/mdc-frontend.utils.event-bus";

import { useEventBus } from "hooks/useEventBus";
import { fetchUserProductsAuthorizations } from "services/apiClient/shellApiClient";

export interface ProductAuthorizationsProps {
  dlAuthorized: boolean;
  pssAuthorized: boolean;
  dssAuthorized: boolean;
  monitoringAuthorized: boolean;
}

export const initialProductAuths: ProductAuthorizationsProps = {
  dlAuthorized: false,
  pssAuthorized: false,
  dssAuthorized: false,
  monitoringAuthorized: false,
};

export const useProductAuthorizations = () => {
  const [authenticated] = useEventBus(EventBusTopic.IsAuthenticated);

  const [productAuthorizations, setProductAuthorizations] =
    useState<ProductAuthorizationsProps>(initialProductAuths);

  useEffect(() => {
    if (authenticated) {
      fetchUserProductsAuthorizations().then((productAuths) => {
        if (productAuths) {
          setProductAuthorizations(productAuths);
        }
      });
    } else if (authenticated === false) {
      setProductAuthorizations(initialProductAuths);
    }
  }, [authenticated]);

  return { productAuthorizations };
};
